import React, { Component } from "react";
import { Button, Col, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import RemoteTable from "../../../../../../components/Common/RemoteTable";
import SalaryModal from "./SalaryModal";

class SalaryCondition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      deleteAlert: null,
      viewAddPayout: false,
      editData: null,
      deleteStack: [],
      checkboxStack: [],
      selectedGroupID: null,
    };
  }

  componentDidMount() { }

  handleTableChange = data => {
    this.props.getSalaryConditions({
      ...this.props.data,
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddPayoutModal = () => {
    this.setState(prevState => ({
      viewAddPayout: !prevState.viewAddPayout,
      editData: null,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          type: "single",
          onConfirm: () => {
            this.props.deleteSalaryCondition(this.props.user_id, [row.id], {
              ...this.props.data,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <React.Fragment>
          {!!this.props.permissions?.["change_salaryconditionsmodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickRow(e, row, "edit")}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {!!this.props.permissions?.["delete_salaryconditionsmodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    // const nameFormatter = (cell, row, label) => {
    //   return (
    //     <NameLink onClick={e => onClickRow(e, row, "edit")}>
    //       {row[label]}%
    //     </NameLink>
    //   );
    // };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    // const onClickDeleteSelected = () => {
    //   this.handleChangeDeleteAlert({
    //     type: "stack",
    //     onConfirm: () => {
    //       this.props.deleteSalaryCondition(this.state.deleteStack);
    //       this.setState(() => ({
    //         deleteStack: [],
    //       }));
    //       this.handleChangeDeleteAlert(null);
    //     },
    //   });
    // };

    const dateFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row["date_from"] || "empty"} - {row["date_to"] || "present"}
        </NameLink>
      );
    };

    const columns = [
      {
        dataField: "rate",
        text: "Rate $",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "rate"),
      },
      {
        dataField: "_",
        text: "Date range",
        sort: true,
        formatter: (cell, row) => dateFormatter(cell, row),
      },
      {
        dataField: "Actions",
        text: "Actions",
        sort: true,
        formatter: (cell, row) => actionsFormatter(cell, row),
      },
    ];

    const onClickRow = (e, row, type) => {
      this.setState(prevState => ({
        viewAddPayout: !prevState.viewAddPayout,
        editData: type === "edit" ? row : null,
      }));
    };

    // const handleOnSelect = (row, isSelect) => {
    //   if (isSelect) {
    //     this.setState(() => ({
    //       deleteStack: [...this.state.deleteStack, row.id],
    //     }));
    //   } else {
    //     this.setState(() => ({
    //       deleteStack: this.state.deleteStack.filter(x => x !== row.id),
    //     }));
    //   }
    // };

    // const handleOnSelectAll = (isSelect, rows) => {
    //   const ids = rows.map(r => r.id);
    //   if (isSelect) {
    //     this.setState(() => ({
    //       deleteStack: ids,
    //     }));
    //   } else {
    //     this.setState(() => ({
    //       deleteStack: [],
    //     }));
    //   }
    // };

    const handleAction = () => {
      this.setState(prevState => ({
        viewAddPayout: !prevState.viewAddPayout,
        editData: null,
      }));
    };

    return (
      <React.Fragment>
        {this.state.viewAddPayout && (
          <SalaryModal
            toggle={this.toggleViewAddPayoutModal}
            isOpen={this.state.viewAddPayout}
            updateSalary={this.props.updateSalaryCondition}
            addSalary={this.props.addSalaryCondition}
            editData={this.state.editData}
            permissions={this.props.permissions}
            user_id={this.props.user_id}
          />
        )}

        {this.state.deleteAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Delete"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle=""
            title={`Delete`}
            onCancel={() => this.handleChangeDeleteAlert(null)}
            onConfirm={this.state.deleteAlert.onConfirm}
          >
            <p>Are you sure want to delete this salary condition?</p>
          </SweetAlert>
        )}

        <Row>
          <Col sm="4">
            <h4 style={{ marginTop: "6px" }}>Salary conditions</h4>
          </Col>
          <Col sm="8">
            <div className="text-end">
              {!!this.props.permissions?.[
                "add_salaryconditionsmodel"
              ] && (
                  <Button
                    type="button"
                    color="success"
                    className={`btn-rounded mb-2`}
                    onClick={() => handleAction()}
                    style={{
                      width: 38
                    }}
                  >
                    <i className="mdi mdi-plus me-1" />
                  </Button>
                )}
            </div>
          </Col>
          <Col className="col-12">
            <>
              <RemoteTable
                onTableChange={this.handleTableChange}
                columns={columns}
                data={this.props.data}
                loading={this.props.loader}
                // selectRow={{
                //   mode: "checkbox",
                //   selectColumnPosition: "left",
                //   selected: this.state.selected,
                //   onSelect: handleOnSelect,
                //   onSelectAll: handleOnSelectAll,
                // }}
                search_input={false}
                disable_pages
              />
            </>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

SalaryCondition.propTypes = {
  data: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
    page: PropTypes.number,
  }).isRequired,
  loader: PropTypes.bool,
  getSalaryConditions: PropTypes.func.isRequired,
  deleteSalaryCondition: PropTypes.func.isRequired,
  updateSalaryCondition: PropTypes.func.isRequired,
  addSalaryCondition: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  user_id: PropTypes.string
};

export default SalaryCondition;